import { render, staticRenderFns } from "./category-child.vue?vue&type=template&id=a1118018&scoped=true"
import script from "./category-child.vue?vue&type=script&lang=ts"
export * from "./category-child.vue?vue&type=script&lang=ts"
import style0 from "./category-child.vue?vue&type=style&index=0&id=a1118018&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1118018",
  null
  
)

export default component.exports